"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Base implementation for an API.
 * All properties must be `async` callable or return a `Promise`
 */
class ApiBase {
}
//# sourceMappingURL=api.js.map